// ignore on next line prevents interface Props from triggering eslint err
// eslint-disable-next-line no-unused-vars
import InfiniteScroll, { Props }  from "react-infinite-scroll-component"
import PanelLoading from "../PanelLoading"

/**
 * Wrapper component for react-infinite-scroll-component.
 *
 * height defaults to `calc(100vh - 80px)`, which attempts to account for the App's nav-bar component.
 *
 * to programmatically set scroll position to an existing value, pass a Props.initialScrollY value
 * @param { Props } props
 * @returns { JSX.Element<InfiniteScroll> }
 * @constructor
 */

export default function PanelInfiniteScroll(props) {
	return (
		<InfiniteScroll
			height={props.fitContent ? "" : "calc(100vh - 80px)"}
			{...props}
			loader={<PanelLoading />}
		>
			{props.children}
		</InfiniteScroll>
	)
}
